import { Box, Flex, Grid, SimpleGrid, Text, Image } from "@chakra-ui/react";
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import config from '@config';
import KarmaSliderComponent from "./KarmaSliderComponent";
import ContentArea from "./ContentArea";
import Link from "next/link";
import { useBreakpointValue } from '@chakra-ui/react';
import { useMediaQuery } from 'react-responsive';
import SimpleButton from "./Buttons/SimpleButton";


let KarmaBookInfo = ({ sectionContent, styleConfig }) => {    

    const isTab = useMediaQuery({ minWidth: 765 });

    return <Box id="kb-section"
        pos={'relative'}
        height={{ base: 'auto', md: 'auto', lg: 'auto', xl: 'auto' }}
        bg={'#fff'}
        w={'100%'}
        pt={{ base: '40px', md: '100px', lg: '100px', xl: '130px' }}
        pb={{ base: '50px', md: '100px', lg: '100px', xl: '130px' }}
        bgImage={sectionContent?.[2]?.image?.url}
    >
        <Grid
            templateColumns={{ md: '1fr', lg: '1fr', xl: "1fr 1fr" }} gap={{ base: 0, md: 20 }}>
            <Box
                display={'flex'}
                justifyContent={{ base: 'center', md: 'center', lg: 'center', xl: 'left' }}
                alignItems={{ base: 'center', md: 'center', lg: 'center', xl: "end" }}
                flexDir={'column'}
                zIndex={1} className="bookContent2">
                <Box
                    width={{ base: '95%', md: '658px', lg: '658px', xl: '599px' }}
                >
                    <Box
                        display={{ base: 'none', md: 'none', lg: 'none', xl: 'block' }} mt={{ md: '-2rem', lg: "-1rem", xl: '1rem' }} mb={{ md: '-1rem', lg: '-1rem', xl: '-1rem' }}>
                        <ContentArea
                            tAlign={'left'}
                            fontFamily={'var(--AustinMedium)'}
                            mainContent={sectionContent?.[1]?.body?.value}
                            sectionContent={sectionContent?.[1]?.body}
                            color={"#B7870C"}
                            maxW={'100%'}
                        />
                    </Box>
                    <ContentArea
                        width={{ base: '95%', md: '658px', lg: '658px', xl: '599px' }}
                        tAlign={'left'}
                        fontFamily={'var(--FedraSansStd-book)'}
                        color={'#000000'}
                        mainContent={sectionContent?.[0]?.titleBody?.value}
                        sectionContent={sectionContent?.[0]?.titleBody}
                        font={{ base: '16px', md: '20px' }}
                        fontWeight={400}
                        lineHeight={"34px"}
                        mx={'0px'}
                        maxW={'100%'}
                    />

                    <SimpleButton sectionContent={sectionContent?.[0]?.cta?.[0]} />
                </Box>
            </Box>
            <Box
                order={{ base: -1, md: -1, lg: -1, xl: 1 }}
                display={'flex'} flexDirection={{ base: 'column', md: 'column', xl: 'row' }}
                justifyContent={{ base: 'center', md: "center", lg: 'center', xl: 'left' }}>
                <Box display={{ base: 'block', md: 'block', lg: 'block', xl: 'none' }} className="mobBookContent2"
                    justifyContent={'center'}
                    alignItems={'center'}
                >
                    <ContentArea
                        tAlign={{ base: 'left', md: 'center' }}
                        fontFamily={'var(--AustinMedium)'}
                        mainContent={sectionContent?.[1]?.body?.value}
                        sectionContent={sectionContent?.[1]?.body}
                        fontWeight={500}
                        font={{ base: '34px', md: "60px" }}
                        lineHeight={{ base: '36px', md: "60px" }}
                        color={'#B7870C'}
                        mx={'0px'}
                        maxW={{ base: '400px', md: '650px' }}
                    />
                </Box>
                <Flex
                    justifyContent={'center'} alignItems={'center'}
                >
                    <Box mb={{ base: '-2rem', md: '-6rem' }}>
                        <LazyLoadImageComponent
                            src={sectionContent?.[0]?.image?.url}
                            width={{ base: '283px', md: '359px', lg: '359px', xl: '558px' }}
                            height={{ base: '406px', md: '514px', lg: '514px', xl: '717px' }}
                        />
                    </Box>
                </Flex>
            </Box>
        </Grid>

        <style>
            {`  .bookContent2 p:empty {
                margin-bottom: ${isTab ? '2rem' : '1rem'};
            }
            .bookContent2 h1 {
                width: 595px;
                font-weight: 500;
                font-family: var(--AustinMedium);
                font-size: 60px;
                line-height: 60px;
                color: #B7870C;
            }
                .bookContent2 h3 {
                font-family: var(--FedraSansStd-medium);
                font-size: 26px;
                color: #030040;
                font-weight: 500;
                text-transform: uppercase;
                margin-top: 1rem;
            }
               
                .mobBookContent2 h3 {
                font-size: ${isTab ? '26px' : '16px'};
                line-height: 33.18px;
                color: #030040;
                font-family: var(--FedraSansStd-medium);
                margin-top: ${isTab ? '1rem' : "0.2rem"};
            }
            
            `}
        </style>
    </Box>

}

export default KarmaBookInfo;